import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER  } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DataserviceComponent } from './shared/dataservice/dataservice.component';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { HttpClientModule } from '@angular/common/http';
import { CreateCaseComponent } from './create-case/create-case.component';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FetchdataServiceService } from './fetchdata-service.service';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ExistingCaseComponent } from './existing-case/existing-case.component';
import { WrongRouteComponent } from './wrong-route/wrong-route.component';
import { PhoneMaskDirective } from './phone-mask.directive';
import { VINServiceService } from './vinservice.service';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    CreateCaseComponent,
    DataserviceComponent,
    ExistingCaseComponent,
    WrongRouteComponent,
    PhoneMaskDirective
   
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    MatProgressSpinnerModule
 
  ],
  providers: [DataserviceComponent,

    //{ provide: APP_INITIALIZER, useFactory: dataProviderFactory, deps: [DataserviceComponent], multi: true },

    CookieService, { provide: LocationStrategy, useClass: PathLocationStrategy }, VINServiceService],
  bootstrap: [AppComponent]
})
export class AppModule {


	
}

export function dataProviderFactory(provider: DataserviceComponent) {
  return () => provider.LoadContent();
}
